<template>
  <div class="container">
    <h2>Optional: Passen Sie Ihren individuellen Liquiditätsbedarf an</h2>
    <div class="row">
      <div class="col-12">
        <div class="box">
           <line-chart class="linechart col-12" :chart-data="datacollection" :options="options"></line-chart>
        </div>
      </div>
    </div>
    <div class="row">
      <div class="col-md-6">
        <div class="box">
        <label for="">Sollzinssatz (in %)</label>
        <app-rangeslider 
          :minVal="0"
          :maxVal="10"
          :val="getSollzins"
          :dynamic="dynamic.Sollzins"
          :step="0.1"
          >
          <template v-slot:minval>0 %</template>
          <template v-slot:maxval>10 %</template>
        </app-rangeslider>

        <div class="row">
          <div class="col-md-3">
            <input class="form-control mt-2" type="number" min="0" step="0.1" v-model="sollzins">
          </div>
          <div class="col-md-9">
            <div class="form-group mt-2 d-flex justify-content-end">
              <label for="">Berechnung in Euro</label>
              <input class="form-control" disabled :value="sollzinsTotal">
            </div>
          </div>
        </div>
        </div>
      </div>

      <div class="col-md-6">
        <div class="box">
          <label for="">Liquiditätsprovision (in %)</label>
          <app-rangeslider 
          :minVal="0" 
          :maxVal="1.5"
          :val="getLiqProv"
          :dynamic="dynamic.LiqProv"
          :step="0.1"
          >
          <template v-slot:minval>0 %</template>
          <template v-slot:maxval>1.5 %</template>
        </app-rangeslider>

        <div class="row">
          <div class="col-md-3">
            <input class="form-control mt-2" type="number" min="0" step="0.1" v-model="liqProv">
          </div>
          <div class="col-md-9">
            <div class="form-group mt-2 d-flex justify-content-end">
              <label for="">Berechnung in Euro</label>
              <input class="form-control" disabled :value="liqprovTotal">
            </div>
          </div>
        </div>
        </div>
      </div>

    </div>
    <button class="btn btn-primary" @click="fillTotal">Berechnen</button>
  </div>
</template>

<script>
  import {mapGetters} from 'vuex'
  import {numberMixin} from '../mixins/numberMixin'
  import LineChart from '../charts/linechart'
  import Rangeslider from './RangeSlider'

  export default {
    mixins: [numberMixin],
    components: {
      LineChart,
      'app-rangeslider': Rangeslider
    },
    data () {
      return {
        dynamic: {
          LiqProv: 'LiqProv',
          Sollzins: 'Sollzins'
        },
        sollzinsTotal: 0,
        liqprovTotal: 0,

        datacollection: {},
        options: {},
      }
    },
    mounted () {
      this.fillData()
      this.fillTotal()
    },
    methods: {
      fillData () {
        this.datacollection = {
          labels: this.generateLabels(this.getKonto),
          datasets: [{
              label: 'Break-Even',
              data: [{
                x: this.getIntersection().x,
                y: this.getIntersection().y
            }],
              borderColor: "red",
              pointBackgroundColor: 'red',
              fill: false,
              borderWidth: 1
            },       
            {
              label: 'Sollzinssatz',
              data: this.generateSollzins,
              borderColor: "#ff8148",
              fill: false,
              pointRadius: 0,
              borderWidth: 1
            }, {
              label: 'Liquiditätsprovision',
              data: this.generateLiqprov,
              borderColor: "#ffe59f",
              fill: false,
              pointRadius: 0,
              borderWidth: 1
            },
          ]
        },
        this.options = {
          tooltips: {
            callbacks: {
              title: function() {}, //Titel verbergen
              label: (tooltipItem) => {

                let arr = [tooltipItem.yLabel, tooltipItem.xLabel]
                let formatArr = arr.map((this.formatNumber))
                formatArr[0] = 'Liquiditätsaufwand: ' + formatArr[0] + ' €';
                formatArr[1] = 'Kontokorrentrahmen: ' + formatArr[1] + ' €'
                return formatArr;
              },
            }
          },
          responsive: true,
          maintainAspectRatio: false,
          scales: {
            xAxes: [{
              type: 'linear', 
              display: true,
              scaleLabel: {
                display: true,
                labelString: 'Kontokorrentrahmen (in EURO)'
              },
              ticks: {
                callback: (value) => {
                  return this.formatNumber(value)
                },
                suggestedMin: 0,
                suggestedMax: this.getKonto
              }
            }],
            yAxes: [{
              display: true,
              scaleLabel: {
                display: true,
                labelString: 'Liquiditätsaufwand (in EURO)'
              },
              ticks: {
                callback: (value) => {
                  return this.formatNumber(value)
                },
                max: 20000,
                min: 0,
                stepSize: 20000 / 10
              },
            }]
          },
        }
      },
      fillTotal () {
        this.sollzinsTotal = this.formatNumber(this.sollzinsCalc)
        this.liqprovTotal = this.formatNumber(this.liqprovCalc)
        this.fillData();
      },
      generateLabels (val) {
        let labels = [];
        let label = 0;
        let value = val / 10;
        for (let i = 0; i < 11; i++) {
          labels.push(label);
          label = Math.round(value + label)
        }
        return labels
      },
      getIntersection() {
        var y2=this.generateLiqprov[2].y, y1=this.generateLiqprov[1].y,x2=this.generateLabels(this.getKonto)[2],x1=this.generateLabels(this.getKonto)[1],x3 = x1, x4 = x2, y4=this.generateSollzins[2].y,y3=this.generateSollzins[1].y;
        var x=((x1*y2-y1*x2)*(x3-x4)-(x1-x2)*(x3*y4-y3*x4))/((x1-x2)*(y3-y4)-(y1-y2)*(x3-x4));
        var y=((x1*y2-y1*x2)*(y3-y4)-(y1-y2)*(x3*y4-y3*x4))/((x1-x2)*(y3-y4)-(y1-y2)*(x3-x4));
        x = Math.round(x*100)/100;
        y = Math.round(y*100)/100;
        return {x:x,y:y}  
      }
  },
  computed: {
    ...mapGetters(['getCredit','getKonto','getSollzins','getLiqProv']),
    credit: {
      get() {
        return this.$store.getters.getCredit
      },
      set(input) {
        this.$store.commit('updateCredit', input)
      }
    },
    liqProv: {
      get() {
          return this.$store.getters.getLiqProv
      },
      set (value) {
          this.$store.commit('updateLiqProv', value)
      }
    },
    sollzins: {
      get() {
          return this.$store.getters.getSollzins
      },
      set(input) {
          this.$store.commit('updateSollzins', input)
      }
    },
    sollzinsCalc () {
      return (this.getCredit*this.getSollzins)/100
    },
    liqprovCalc () {
      return ((this.getKonto - this.getCredit)*this.getLiqProv)/100
    },
    generateSollzins () {
      let arr = this.generateLabels(this.getKonto).map((element) => {
          return {x: element, y: (element*this.getSollzins) / 100}
      })
      return arr
    },
    generateLiqprov () {
      let arr = this.generateLabels(this.getKonto).map((element, i) => {
          return {
            x: element, 
            y: ((this.generateLabels(this.getKonto).reverse()[i] * this.getLiqProv) / 100)
          }
      })
      return arr
    },
  }
}
</script>

<style scoped>
.linechart {
  height: 500px;
  background-color: #fff;
  padding: 20px;
}

input.form-control {
  max-width: 150px;
}

label {
  display: flex;
  flex-direction: column;
  justify-content: center;
  margin-right: 10px;
}
</style>


